import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";

export const taskAddTagMutation = ({
  taskId,
  flag,
}: {
  taskId: string
  flag: string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${taskId}/addTags?tag=${flag}`,
    codec: t.unknown,
  })
